export const postInvoices = async ({ body }) => {
    const response = await fetch(`/invoices`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

export const getInvoiceDetails = async (id) => {
    const response = await fetch(`/invoices/${id}.json`);

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError("Oops, não recebemos JSON!");
    }

    const data = await response.json();

    if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${data.error}`);
    }

    return data;
};

export const getCustomerLastInvoice = async (id) => {
    const response = await fetch(`/invoices?customer_ids[]=${id}&per_page=1`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

export const postInstallmentPayment = async ({ body, invoiceId }) => {
    const response = await fetch(`/invoices/${invoiceId}/installment_manual_payment`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

export const cancelInvoice = async ({ invoiceId }) => {
    const response = await fetch(`/invoices/${invoiceId}/cancel`, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

export const postFiscalInvoiceService = async ({ body, invoiceId }) => {
    const response = await fetch(`/invoices/${invoiceId}/fiscal_service_invoices`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

export const getFiscalInvoiceService = async (id) => {
    const response = await fetch(`/invoices/${id}/fiscal_service_invoices`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    const responseJson = await response.json();

    if (!response.ok) {
        throw new Error(`Error ${response.status}: ${responseJson.error}`);
    }
    return responseJson;
}

